import {
	AbpApplicationConfigurationService,
	ConfigStateService,
	CONTENT_STRATEGY,
	CORE_OPTIONS,
	DomInsertionService,
	ReplaceableComponentsService
} from '@abp/ng.core';

import { APP_INITIALIZER, Component, Injector, RendererFactory2 } from '@angular/core';
import { AccountLayoutComponent } from '../components/account-layout/account-layout.component';
import { ApplicationLayoutComponent } from '../components/application-layout/application-layout.component';
import { EmptyLayoutComponent } from '../components/empty-layout/empty-layout.component';
import { SettingManagementComponent } from '../components/settings/setting-management/setting-management.component';
import { CurrentUserImageComponent } from '../components/current-user-image/current-user-image.component';
import styles from '../constants/styles';
import { eThemeMetronicComponents } from '../enums/components';
import {
	setStyle
} from '../utils/layout.utils';
import { LayoutService } from '../services/layout.service';
import { switchMap, take, tap } from 'rxjs/operators';
import { RoutesComponent } from '../components/routes/routes.component';
import { LayoutInitService } from '../services/layout-initial.service';
import { LayoutStateService } from '../services/layout-state.service';
export const METRONIC_THEME_STYLES_PROVIDERS = [
	{
		provide: APP_INITIALIZER,
		useFactory: configureStyles,
		deps: [Injector],
		multi: true,
	},
];

export function configureStyles(injector: Injector) {
	return () => {
		injector.get(LayoutInitService);

		const rendererFactory = injector.get(RendererFactory2);
		const domInsertion = injector.get(DomInsertionService);
		const replaceableComponents = injector.get(ReplaceableComponentsService);
		const configState = injector.get(ConfigStateService);
		const coreOptions = injector.get(CORE_OPTIONS);

		const layoutService = injector.get(LayoutService);
		const appConfigService = injector.get(AbpApplicationConfigurationService);
		const layoutState = injector.get(LayoutStateService);

		initApplicationState(configState, appConfigService);

		rendererFactory
			.createRenderer(document.body, null)
			.addClass(document.body, 'abp-application-layout');
		domInsertion.insertContent(CONTENT_STRATEGY.AppendStyleToHead(styles));

		listenToMetronicSettings(layoutService, configState);

		const setStyleCb = createSetStyle(injector, configState);
		if (coreOptions.skipGetAppConfiguration) setStyleCb();

		configState
			.createOnUpdateStream(state => state)
			.subscribe(() => {
				setStyleCb();
			});

		initLayouts(replaceableComponents);
	};
}


/**
 * 不知道为啥没有触发全局状态获取，这里手动获取一次
 * @param configState 
 * @param appConfigService 
 */
function initApplicationState(configState: ConfigStateService, appConfigService: AbpApplicationConfigurationService) {
	configState.getAll$().pipe(
		take(1),
		switchMap(x => appConfigService
			.get()
			.pipe(tap(res => configState.setState(res)))),
	).subscribe();
}

function listenToMetronicSettings(layoutService: LayoutService, configState: ConfigStateService) {
	const MetronicSettings$ = configState.getSettings$('Metronic');
	const layoutConfigKey = 'Hedou.Abp.MetronicTheme.Layout';
	MetronicSettings$.subscribe(settings => {

		// layoutService.setLayoutBoxed(settings[`${layoutConfigKey}.Boxed`] === 'True');
		// layoutService.setMenuStatus(
		// 	Layout.MenuStatus[settings[`${layoutConfigKey}.MenuStatus`] as string] || 0,
		// );
		// layoutService.setMenuPlacement(
		// 	Layout.MenuPlacement[settings[`${layoutConfigKey}.MenuPlacement`] as string] || 0,
		// );
	});
}

function createSetStyle(injector: Injector, configState: ConfigStateService) {
	return () =>
		setStyle(
			Number(
				(configState.getSetting('Hedou.Abp.MetronicTheme.Style') || 'Style1').replace('Style', ''),
			),
			injector,
		);
}

function initLayouts(replaceableComponents: ReplaceableComponentsService) {
	replaceableComponents.add({
		key: eThemeMetronicComponents.ApplicationLayout,
		component: ApplicationLayoutComponent,
	});
	replaceableComponents.add({
		key: eThemeMetronicComponents.AccountLayout,
		component: AccountLayoutComponent,
	});
	replaceableComponents.add({
		key: eThemeMetronicComponents.EmptyLayout,
		component: EmptyLayoutComponent,
	});
	replaceableComponents.add({
		key: eThemeMetronicComponents.Routes,
		component: RoutesComponent
	});

	replaceableComponents.add({
		key: eThemeMetronicComponents.SettingManagement,
		component: SettingManagementComponent
	});

	replaceableComponents.add(
		{
			key: eThemeMetronicComponents.CurrentUserImage,
			component: CurrentUserImageComponent
		}
	)
}
